import { FunctionComponent, useEffect, useRef, useState } from "react";
import Table from "../../../Components/Table/Table";
import CustomToolbar from "../../../Components/Table/components/CustomToolbar";
import ButtonField from "../../../Components/Button/ButtonField";
import { Columns } from "../../../Components/Table/ITable";
import { GridRenderCellParams } from "@mui/x-data-grid";
import { useAppDispatch, useAppSelector } from "../../../Redux/Store/Hooks";
import TableSearch from "../../../Components/Table/components/TableSearch";
import IconButtonField from "../../../Components/Button/IconButtonField";
import { SvgIcon } from "@mui/material";

import { ReactComponent as Edit } from "../../../Assets/Images/edit.svg";
import { ReactComponent as Delete } from "../../../Assets/Images/delete.svg";
import { ReactComponent as RefreshButton } from "../../../Assets/Images/RefreshButton.svg";

import Dialog from "../../../Components/Dialog/Dialog";
import ResponseDialog from "../../../Components/ResponseDialog/ResponseDialog";
import DeleteDialog from "../../../Components/DeleteDialog/DeleteDialog";

import TutorForm from "./TutorForm";
import { ITutor } from "./ITutor";
import { tutorsRead } from "../../../Redux/Slices/Booklet/Admin/Tutors/TutorsRead";
import {
  clearTutorCreate_Update,
  TutorCreate_Update,
} from "../../../Redux/Slices/Booklet/Admin/Tutors/TutorsCreate_Update";

const Tutor: FunctionComponent = () => {
  const [dialogOpen, setDialogOpen] = useState(false);
  const [Isedit, setIsEdit] = useState(false);
  const [deleteDialogData, setDeleteDialogData] = useState<any>({});
  const [initialValues, setInitialValues] = useState<ITutor | {}>({
    status: true,
  });

  console.log(Isedit,"dialogue for tutuor")
  const Role = "TUTOR";

  const formRef = useRef<HTMLFormElement>(null);
  const dispatch = useAppDispatch();

  const { data: tutorList } = useAppSelector((state) => state.TutorsReadSlice);
  const { data: addOrUpdateTutor } = useAppSelector(
    (state) => state.TutorsCreate_UpdateSlice
  );

  console.log(addOrUpdateTutor,"respoll")
  // Columns definition
  const columns: Columns = [
    {
      field: "index",
      renderHeader: () => <b>S.No</b>,
      width: 80,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "username",
      renderHeader: () => <b>Name</b>,
      flex: 1,
      type: "string",
      align: "center",
      headerAlign: "center",
    },
    {
      field: "email",
      renderHeader: () => <b>Email</b>,
      flex: 1,
      type: "string",
      align: "center",
      headerAlign: "center",
    },
    {
      field: "phone_no",
      renderHeader: () => <b>Phone</b>,
      flex: 1,
      type: "string",
      align: "center",
      headerAlign: "center",
    },
    // {
    //   field: "yeargroup_name",
    //   renderHeader: () => <b>Year Group</b>,
    //   flex: 1,
    //   align: "center",
    //   headerAlign: "center",
    // },
    // {
    //   field: "country",
    //   renderHeader: () => <b>Country</b>,
    //   flex: 1,
    //   align: "center",
    //   headerAlign: "center",
    // },
    {
      field: "status",
      renderHeader: () => <b>Status</b>,
      flex: 1,
      align: "center",
      headerAlign: "center",
      cellClassName: (params) =>
        `activename ${params.row.status ? "active" : "inactive"}`,
      valueFormatter: (params) =>
        params.value === true ? "Active" : "Inactive",
    },
    {
      field: "action",
      renderHeader: () => <b>Action</b>,
      flex: 1,
      type: "actions",
      align: "center",
      headerAlign: "center",
      renderCell: (params: GridRenderCellParams<ITutor>) => (
        <>
          <IconButtonField
            onClick={() => {
              setInitialValues({ ...params.row });
              setDialogOpen(true);
              setIsEdit(true);
            }}
            disabled={dialogOpen}
          >
            <SvgIcon sx={{ fill: "none" }} component={Edit} inheritViewBox />
          </IconButtonField>
          {/* <IconButtonField
            onClick={() => {
              setDeleteDialogData(params.row);
              setDeleteDialogOpen(true);
            }}
          >
            <SvgIcon component={Delete} inheritViewBox />
          </IconButtonField> */}
        </>
      ),
    },
  ];

  const tutors = Array.isArray(tutorList?.data)
    ? tutorList?.data.map((tutor, index) => ({
        ...tutor,
        id: tutor.id,
        index: index + 1,
      }))
    : [];

  // Fetch data
  useEffect(() => {
    dispatch(tutorsRead({ role: Role }));
    setIsEdit(false);
  }, [addOrUpdateTutor, dispatch]);

  useEffect(() => {
    return () => {
      dispatch(clearTutorCreate_Update());
    };
  }, []);




  return (
    <>
      <Table rows={tutors ?? []} columns={columns}>
        <CustomToolbar>
          <h6>Tutors</h6>
          <TableSearch />
          <ButtonField
            className="tabel_add_new_button"
            onClick={() => {
              setInitialValues({
                id: 0,
                username: "",
                email: "",
                phone_no: "",
                role: 0,
                password: "",
                confirm_password: "",
                status: true,
              });
              setDialogOpen(true);
              setIsEdit(false);
            }}
            disabled={dialogOpen}
            toolTip="Add new"
          >
            Add new
          </ButtonField>

          <IconButtonField
            className="refresh_btn"
            toolTip="Refresh"
            onClick={() => dispatch(tutorsRead({ role: Role }))}
          >
            <SvgIcon
              className="refresh_svg_icon"
              component={RefreshButton}
              inheritViewBox
            />
          </IconButtonField>
        </CustomToolbar>
      </Table>

      {/* Tutor Form Dialog */}
      <Dialog
        open={dialogOpen}
        dialogClassName="dialog_double_input"
        Dialog_Title={`${
          (initialValues as Partial<ITutor>).id ? "Update" : "Add"
        } Tutor`}
        Dialog_Content={
          <TutorForm
            formRef={formRef}
            initialValues={initialValues}
            setInitialValues={setInitialValues}
              isEdit={Isedit}
          />
        }
        Dialog_Actions={
          <>
            <ButtonField
              className="form_cancel_button"
              onClick={() => setDialogOpen(false)}
            >
              Cancel
            </ButtonField>
            <ButtonField
              className="form_save_button"
              onClick={() => {
                formRef.current?.requestSubmit();
              }}
            >
              Save
            </ButtonField>
          </>
        }
      />

      <ResponseDialog
        okFunction={() => setDialogOpen(false)}
        response={addOrUpdateTutor}
        parentDialog={setDialogOpen}
      />

    </>
  );
};

export default Tutor;
